import { render } from "./ButtonPublisherRequests.vue?vue&type=template&id=6966860c"
import script from "./ButtonPublisherRequests.vue?vue&type=script&lang=js"
export * from "./ButtonPublisherRequests.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__